import { useCallback } from "react";

import { useProductRoomI18nFormModelContext } from "../../../../_context";

export const useRoomI18nCatchCopy = () => {
	const { viewModel, onSetViewModel } = useProductRoomI18nFormModelContext();

	const { catchCopy } = viewModel;

	const onSetMainTarget = useCallback(
		(input: string) => {
			const value = !catchCopy ? { isEdited: true, value: input } : { ...catchCopy, value: input };

			onSetViewModel([{ key: "catchCopy", value }]);
		},
		[catchCopy, onSetViewModel],
	);

	return {
		catchCopy,
		onSetMainTarget,
	};
};
